module.exports = __webpack_public_path__ + "static/media/VF_Model_Outputs.9cf69c86.pdf";